import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: HostCache = {};

export const hostSlice = createSlice({
    name: 'provider-settings-tab-cache',
    initialState,
    reducers: {
        cacheHost(state: HostCache, { payload }: PayloadAction<string>) {
            state.host = payload;
        },
    },
});

export const { cacheHost } = hostSlice.actions;

export default hostSlice.reducer;

export interface HostCache {
    host?: string;
}
